export default __webpack_public_path__ + "static/Goodfirms-a930d7e6217e2c53ef9075de0bbf8ec7.webp";